<template>
  <v-dialog
    :value="enableDialog"
    width="800"
    @click:outside="closeButtonClickEvent"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="emissionUserFormValidation"
    >
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            担当者の{{ targetId ? '編集' : '追加' }}
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-radio-group
                  v-model="forms.person_type"
                  dense
                  label="担当者種別"
                  hide-details="auto"
                  class="mt-0 pt-0"
                  row
                >
                  <v-radio
                    v-for="classification in person_types"
                    :key="classification.value"
                    :label="classification.text"
                    :value="classification.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|alpha_num_only|max:10"
                  name="コード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="forms.code"
                    :error-messages="errors"
                    :placeholder="`例）${forms.person_type === 'deliverer' ? 'A' : 'B'}0001`"
                    dense
                    hide-details="auto"
                    label="コード"
                    outlined
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>コード</span>
                      <span class="ml-1">
                        ({{ forms.code?.length || 0 }} / 10)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:12"
                  name="担当者名"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="forms.name"
                    :error-messages="errors"
                    :placeholder="`${forms.person_type === 'deliverer' ? '例）引渡' : '例）登録'}　太郎`"
                    dense
                    hide-details="auto"
                    label="担当者名"
                    outlined
                    persistent-placeholder
                    required
                  >
                    <template v-slot:label>
                      <span>担当者名</span>
                      <span class="ml-1">
                        ({{ forms.name?.length || 0 }} / 12)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  name="担当者利用事業場"
                >
                  <v-select
                    v-model="forms.emission_location_id"
                    :error-messages="errors"
                    :items="emissionLocations"
                    clearable
                    dense
                    item-text="text"
                    item-value="id"
                    hide-details="auto"
                    label="担当者利用事業場"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
    </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EmissionUserDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    emissionId: {
      type: Number,
      default: () => null,
    },
    targetId: {
      type: Number,
      default: () => null
    },

  },
  data() {
    return {
      forms: {
        id: null,
        code: null,
        name: null,
        person_type: 'deliverer',
        emission_location_id: null
      },
      person_types: [],
      emissionLocations: [],
    }
  },
  computed: {},
  watch: {
    /**
     * enableDialogの監視
     * trueに変更された場合は初期表示情報を取得
     * @param newVal
     */
    enableDialog (newVal) {
      Object.assign(this.$data.forms, this.$options.data().forms);
      this.$nextTick(() => this.$refs.emissionUserFormValidation.reset())
      if (newVal) {
          this.setVariable()
      }
    }
  },
  created () {
  },
  methods: {
    ...mapActions('DriverMasterEmissionUser', {
      newEmissionUser: 'new',
      editEmissionUser: 'edit',
      createEmissionUser: 'create',
      updateEmissionUser: 'update',
    }),
    ...mapActions('DriverMasterSearchEmissionLocation', {
      fetchEmissionLocation: 'index'
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.emissionUserFormValidation.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    /**
     * 登録処理
     */
    sendRegistrationInformation(){
      if (this.targetId) {
        this.updateEmissionUser({ emission_id: this.emissionId, id: this.targetId, params: this.forms }).then(() => {
          this.$emit('registerEvent')
        })
      } else {
        this.createEmissionUser({ emission_id: this.emissionId, params: this.forms }).then(() => {
          this.$emit('registerEvent')
        })
      }
    },
    /**
     * 初期表示情報の設定
     */
    setVariable () {
      /*
        json.value emission_location.id
        json.text  emission_location.name
        json.code  emission_location.code
        json.label "#{emission_location.code}: #{emission_location.name}"
        json.parent_id emission_location.emission_id
       */
      this.fetchEmissionLocation({id: this.emissionId}).then((content) => {
        this.emissionLocations = content.emission_locations
      })

      if (this.targetId) {
        this.editEmissionUser({ emission_id: this.emissionId, id: this.targetId }).then((content) => {
          this.forms = content
          this.person_types = content.person_types
        })
      } else {
        this.newEmissionUser({ emission_id: this.emissionId }).then((content) => {
          this.forms = content
          this.person_types = content.person_types
        })
      }

    },
  }
}
</script>

<style scoped lang="scss">

</style>
